// extracted by mini-css-extract-plugin
module.exports = {"logoarea":"logoarea_logoarea__237zj","logo":"logoarea_logo__20WSj","title":"logoarea_title__dk5--"};